import { ReactiveVar, makeVar } from '@apollo/client'

import { IProduct } from 'shared/interfaces'
import { PRODUCTS_FILTER_INIT_VALUES, PRODUCTS_FILTER_STORAGE_NAME } from 'shared/consts/filter'
import { getFiltersFromLocalStorage } from 'shared/utils/filters'
import { mergePagination } from 'shared/utils/storePagination'
import { TSortField } from 'shared/types'

export const ProductsStore = {
  productsFilters: {
    read: () => productsFiltersVar()
  },
  getNewReleases: {
    keyArgs: [],
    merge: <T extends object>(existing: T, incoming: T, { args: { input } }: any) =>
      mergePagination('products', existing, incoming, input.offset)
  },
  productsSort: {
    read: () => productSortFieldVar()
  },
  productsFacts: {
    read: () => productsFactsVar()
  }
}

export const productsFactsVar: ReactiveVar<IProduct[]> = makeVar<IProduct[]>([])
export const productsFiltersVar: ReactiveVar<any> = makeVar<any>(
  getFiltersFromLocalStorage(PRODUCTS_FILTER_STORAGE_NAME, PRODUCTS_FILTER_INIT_VALUES)
)
export const productSortFieldVar: ReactiveVar<TSortField> = makeVar<TSortField>({ direction: false, fieldName: '' })
